import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import useMediaQuery from 'src/hooks/useMediaQuery';
import { State } from 'src/types';
import I18next from '../../../i18n';
import { VaultLogo } from '../../foundations/VaultLogo/VaultLogo';
import {
  PrivacyStatementLink,
  StyledLink,
} from './ProductPrivacyStatement.styles';

export interface ProductPrivacyStatementProps {
  showVaultLogo: boolean;
}

export const ProductPrivacyStatement: React.FC<
  ProductPrivacyStatementProps
> = ({ showVaultLogo }: ProductPrivacyStatementProps) => {
  const { t } = useTranslation();
  const isMobile = !useMediaQuery(`(min-width: 480px)`);

  const orgPrivacyStatementUrl = useSelector(
    (state: State) =>
      state.openReporting?.openReportReducer?.privacyStatementUrl,
  );

  const privacyStatementLink = () => {
    return orgPrivacyStatementUrl
      ? orgPrivacyStatementUrl
      : I18next.language?.startsWith('zh')
        ? 'https://vaultplatform.com/product-privacy-statement-chinese/?utm_source=publicreporting'
        : 'https://vaultplatform.com/product-privacy-statement-web/?utm_source=publicreporting';
  };

  return (
    <PrivacyStatementLink>
      {/* Only display Vault logo in footer if it's not displayed at top in OPR */}
      {showVaultLogo && (
        <VaultLogo size={isMobile ? 'xsmall' : 'default'} color="N800" />
      )}
      <StyledLink
        size="medium"
        target="_blank"
        rel="noreferrer"
        href={privacyStatementLink()}
      >
        {t('public.PrivacyStatement')}
      </StyledLink>
    </PrivacyStatementLink>
  );
};

export default ProductPrivacyStatement;
